import { Menu, LogOut, Flower2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { usePartnerAuth } from '@/hooks/usePartnerAuth';
import PortalSwitcher from '@/components/portal/PortalSwitcher';

interface PartnerHeaderProps {
  onMenuToggle: () => void;
}

const PartnerHeader = ({ onMenuToggle }: PartnerHeaderProps) => {
  const { signOut } = useAuth();
  const { partner } = usePartnerAuth();

  const handleSignOut = async () => {
    await signOut('/partner/auth');
  };

  return (
    <header className="sticky top-0 z-40 border-b bg-background">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={onMenuToggle}
          >
            <Menu className="h-5 w-5" />
          </Button>
          <div className="flex items-center gap-2">
            <Flower2 className="h-6 w-6 text-primary" />
            <span className="font-semibold text-lg hidden sm:inline">
              {partner?.name || 'Partner Portal'}
            </span>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <PortalSwitcher />
          <Button
            variant="ghost"
            size="sm"
            onClick={handleSignOut}
            className="text-muted-foreground hover:text-foreground"
          >
            <LogOut className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Sign Out</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default PartnerHeader;
